<style lang="scss" scoped>
    ::v-deep .el-carousel__indicator {
        padding-bottom: 30px;

        .el-carousel__button {
            height: 8px;
            background: #999;
            opacity: .5;
            border-radius: 50px;
        }
    }

    ::v-deep .el-carousel__indicator.is-active button {
        background: #A5D48B;
    }
    .el-carousel__item { text-align: center;}

    .hot-shop {
        padding-top: 70px;

        h2 {
            font-size: 24px;
            text-align: center;
            font-weight: 600;
            margin: 0;
            padding: 0;
        }
        &-more {
            width: 180px;
            text-align: center;
            float: right;
            a {
                display: inline-block;
                padding: 5px 15px;
                background: #90ca6f;
                color: #fff;
                border-radius: 5px;
            }
        }
        .shops {
            padding-top: 30px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            .item {
                width: 345px;
                text-align: center;
                &:hover {
                    /*box-shadow: 0 0 15px rgba(194, 209, 197, .8);*/
                    img {
                        transform: scale(1.1);
                    }
                }

                img {
                    width: 345px;
                    height: 345px;
                    display: block;
                    border: 0;
                    transition: all 0.6s;
                }
                div.img{
                    width: 345px;
                    height: 345px;
                    overflow: hidden;
                }
                div.txt {
                    -moz-box-shadow: 0 3px 8px rgba(194, 209, 197, .4);
                    -webkit-box-shadow: 0 3px 8px rgba(194, 209, 197, .4);
                    box-shadow: 0 3px 8px rgba(194, 209, 197, .4);
                    padding: 20px;
                }

                h3 {
                    font-size: 18px;
                    font-weight: 500;
                    margin: 0;
                }

                p {
                    height: 20px;
                    margin: 10px 0 0;
                    padding: 0;
                    line-height: 20px;
                    overflow: hidden;
                    text-align: center;
                }
            }
        }
    }

    .discount {
        margin-top: 80px;

        .header {
            -moz-box-shadow: 0 0px 8px rgba(194, 209, 197, .4);
            -webkit-box-shadow: 0 0px 8px rgba(194, 209, 197, .4);
            box-shadow: 0 0px 8px rgba(194, 209, 197, .4);

            padding: 35px 0;
            display: flex;
            flex-direction: row;

            .l {
                flex: 1;
                padding-left: 165px;
                text-align: center;

                h3 {
                    margin: 0;
                    font-size: 24px;
                    font-weight: 600;
                }

                div {
                    line-height: 1.6;
                    overflow: hidden;
                    font-size: 14px;
                    padding-top: 20px;

                    a {
                        color: #888;
                        display:inline-block;
                        margin: 0 15px;
                    }

                    a:hover {
                        color: #90ca6f;
                    }
                }
            }

            .more {
                width: 180px;
                padding-top: 20px;
                text-align: center;

                a {
                    display: inline-block;
                    padding: 5px 15px;
                    background: #90ca6f;
                    color: white;
                    border-radius: 5px;
                }
            }
        }
    }

    .goods {
        width: 1200px;
        overflow-x: hidden;
        background-color: #f8f8f8;

        ul {
            width: 1240px;
            margin-left: -20px;

            li {
                float: left;
                width: 290px;
                padding: 10px;

                .item {
                    background: white;
                    padding-top: 20px;
                    text-align: center;

                    img {
                        display: block;
                        margin: auto;
                        width: 220px;
                        height: 220px;
                        border: 0;
                        transition: all 0.6s;

                    }

                    &:hover {
                        /*box-shadow: 0 0 15px rgba(194, 209, 197, .8);*/
                        img {
                            transform: scale(1.1);
                        }
                    }

                    .txt {
                        width: 260px;
                        margin: 30px auto 0;
                        border-top: 1px solid #ddd;
                        display: flex;
                        flex-direction: row;
                        font-size: 14px;
                        line-height: 60px;

                        .title {
                            flex: 2;
                            height: 66px;
                            line-height: 1.2;
                            margin: 10px 0 10px 6px;
                            overflow-y: hidden;
                            text-align: left;
                        }

                        .price {
                            flex: 1;
                            color: #F20347;
                            font-weight: 500;
                            height: 44px;
                            line-height: 22px;
                            padding: 10px 0;
                            .del {
                                text-decoration:line-through;
                                display: block;
                                color: #999;
                                font-size: 12px;
                            }
                        }
                    }
                }
            }
        }
    }

    .hot-sale {
        margin-top: 50px;

        .header {
            padding-top: 30px;

            .t {
                text-align: center;

                h2 {
                    margin: 0;
                    font-size: 24px;
                    font-weight: 600;
                }
            }

            .tabs {
                display: flex;
                flex-direction: row;
                border-bottom: 2px solid #7CB85A;

                .more {
                    display: block;
                    color: #7CB85A;
                    padding-top: 10px;
                }

                .cates {
                    padding-left: 50px;
                    flex: 1;
                    text-align: center;

                    a {
                        display: inline-block;
                        padding: 10px 15px 15px;

                        &.active {
                            color: #7CB85A;
                            background: url("../../assets/frontend/images/icon_sjt.png") bottom center no-repeat;
                        }
                    }

                }
            }
        }
    }
    .banner-item-box {
        width: 100%;
        height: 556px;
        padding-top: 30px;
        background: url("../../assets/frontend/images/banner-bg.png") center center no-repeat;
        background-size: 100% 100%;
        .banner-items {
            width: 1200px;
            height: 520px;
            margin: 0 auto;
            border: 3px solid #ffffff;
        }
    }
</style>
<template>
    <div>
        <!--<div>
            <el-carousel height="680px" :autoplay="false">
                <el-carousel-item v-for="item in bannerAds" :key="item.id">
                    <div :style="'background:url(' + item.imageUrl + ') center center no-repeat; background-size: cover;  height: 100%; width:100%;'"></div>
                </el-carousel-item>
            </el-carousel>
        </div>-->

        <div class="banner-item-box">
            <div class="banner-items">
                <el-carousel height="520px" :autoplay="false">
                    <el-carousel-item v-for="item in bannerAds" :key="item.id">
                        <div :style="'background:url(' + item.imageUrl + ') center center no-repeat; background-size: cover;  height: 100%; width:100%;'"></div>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>

        <div class="container">
            <!--<div class="hot-shop">
                <h2>热门店铺</h2>
                <div class="more hot-shop-more">
                    <router-link to="/shopList">查看更多</router-link>
                </div>
                <div class="icon-xian"></div>
                <div class="shops">
                    <div class="item" :key="item.id" v-for="item in shops">
                        <router-link :to="{path:'/shop/'+item.id}">
                            <div class="img">
                                <img :src="item.imageUrl" :alt="item.name"/>
                            </div>
                            <div class="txt">
                                <h3>{{item.name}}</h3>
                                <p>{{item.address.detail}}</p>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>-->

            <div class="discount">
                <div class="header">
                    <div class="l">
                        <h3>限时特惠</h3>
                        <div>
                            <router-link :key="item.id" :to="{path:'/products?cateId='+item.id}" v-for="item in preferential.categories">{{item.name}}▶</router-link>
                        </div>
                    </div>
                    <div class="more">
                        <router-link to="/products?cateId=0&brandId=0&keywords=&hotSale=false&preferential=true">查看更多</router-link>
                    </div>
                </div>
                <div class="goods">
                    <ul class="clearfix">
                        <li :key="item.id" v-for="item in preferential.items">
                            <div class="item">
                                <router-link :to="{path:'/transaction/'+item.id}" :title="item.name">
                                    <img :src="item.imageUrl" :alt="item.name"/>
                                    <div class="txt">
                                        <div class="title">{{item.name}}</div>
                                        <div class="price">
                                            ${{item.price}}
                                            <span class="del" v-if="item.originalPrice > item.price">原价：${{item.originalPrice}}</span>
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <!--<div class="hot-sale">
                <div class="header">
                    <div class="t">
                        <h2>火爆热销</h2>
                        <div class="icon-xian"></div>
                    </div>
                    <div class="tabs">
                        <div class="cates">
                            <router-link :key="item.id" :to="{path:'/products?cateId='+item.id}" :class="{active:false}" v-for="item in hotSales.categories">{{item.name}}</router-link>
                        </div>
                        <router-link to="/products?cateId=0&brandId=0&keywords=&hotSale=true&preferential=false" class="more">更多></router-link>
                    </div>
                </div>
                <div class="goods" v-if="hotSales.items && hotSales.items.length>0">
                    <ul class="clearfix">
                        <li :key="item.id" v-for="item in hotSales.items">
                            <div class="item">
                                <router-link :to="{path:'/transaction/'+item.id}">
                                    <img :src="item.imageUrl" alt=""/>
                                    <div class="txt">
                                        <div class="title">{{item.name}}</div>
                                        <div class="price">
                                            ${{item.price}}
                                            <span class="del" v-if="item.originalPrice > item.price">原价：${{item.originalPrice}}</span>
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>-->

            <div class="hot-sale" :key="index" v-for="(item, index) in products">
                <div class="header">
                    <div class="t">
                        <h2>{{item.category.name}}</h2>
                        <div class="icon-xian"></div>
                    </div>
                    <div class="tabs">
                        <div class="cates">
                            <router-link :key="b.id" :to="{path:'/products',query:{cateId:item.category.id, brand:b.id}}" :class="{active:false}" v-for="b in item.brands">{{b.name}}</router-link>
                        </div>
                        <router-link :to="{path:'/products',query:{cateId:item.category.id}}" class="more">更多></router-link>
                    </div>
                </div>
                <div class="goods" v-if="item.items && item.items.length>0">
                    <ul class="clearfix">
                        <li :key="pd.id" v-for="pd in item.items">
                            <div class="item">
                                <router-link :to="{path:'/transaction/'+pd.id}">
                                    <img :src="pd.imageUrl" alt=""/>
                                    <div class="txt">
                                        <div class="title">{{pd.name}}</div>
                                        <div class="price">
                                            ${{pd.price}}
                                            <span class="del" v-if="pd.originalPrice > pd.price">原价：${{pd.originalPrice}}</span>
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="watchword">
                <img src="../../assets/frontend/images/pingzhi@2x.jpg" alt=""/>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'home',
        data(){
            return{
                bannerAds: [],
                shops:[],
                hotSales:[],
                products:[],
                preferential:[],
                categoriesAndBrands:[]
            }
        },
        computed: {
            categories () {
                let cates = this.categoriesAndBrands.map((value, key, arr) => {
                    return value.category
                })
                console.log(cates)
                return cates
            },
            brands () {
                if (this.filter.category > 0) {
                    //选了分类就关联下面的品牌
                    let item = this.categoriesAndBrands.filter(x => {
                        return x.category.id === this.filter.category
                    })
                    //console.log("item",item)
                    if (item) {
                        return item[0].brands
                    }
                    return []
                } else {
                    let items = []
                    this.categoriesAndBrands.forEach(function (e) {
                        e.brands.forEach(function (b) {
                            if (items === 0 || items.filter(item => {
                                return item.id === b.id && item.name === b.name
                            }).length === 0) {
                                items.push(b)
                            }
                        })
                    })
                    return items
                }
            }
        },
        mounted () {
            this.getAds();
            this.getShops();
            this.getPreferential();
            this.getCategoriesAndBrands();
            this.getProducts();
            this.getHotSales();
        },
        methods:{
            getAds() {
                this.$axios.get(window.consts.apis.allAds+"?platform=1").then(r=>{
                    if(r.success){
                        this.bannerAds = r.result;
                    }
                })
            },
            getShops(){
                this.$axios.get(window.consts.apis.shopList+"?ShowOnHome=true&Page=1&Size=3").then(r=>{
                    if(r.success){
                        this.shops = r.result.items;
                    }
                })
            },
            //获取首页展示产品
            getProducts(){
                this.$axios.post(window.consts.apis.categoryItems + "?take=8").then(r=>{
                    if(r.success){
                        this.products = r.result;
                    }
                })
            },
            getCategoriesAndBrands () {
                this.$axios.get(window.consts.apis.categoriesAndBrands).then(res => {
                    if (res.success) {
                        this.categoriesAndBrands = res.result
                    }
                })
            },
            //限时特惠
            getPreferential() {
                this.$axios.post(window.consts.apis.preferential + "?take=8").then(res => {
                    if (res.success) {
                        this.preferential = res.result
                    }
                })
            },
            //火爆热销
            getHotSales() {
                this.$axios.post(window.consts.apis.hotSale + "?take=8").then(res => {
                    if (res.success) {
                        this.hotSales = res.result
                    }
                })
            }
        }
    }
</script>
